var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { onError } from '@apollo/client/link/error';
import { Locale } from '@doordash/lib-i18n';
import { configureApollo as configureApolloUtil, } from '@doordash/lib-apollo-utilities';
import { getIdentityUrl } from '../utils/identity_helper';
import LocationPathHelper from '../utils/location_path_helper';
import { HOME_PAGE_PATH } from '../constants/values';
import { getReleaseVersion } from './utils';
export var shouldRedirectOnNetworkError = function (error) {
    var _a;
    var noRedirectValue = {
        shouldRedirect: false,
        redirectPath: null,
    };
    if (!error || !('statusCode' in error) || !('response' in error)) {
        return noRedirectValue;
    }
    if (error.statusCode === 400 || error.statusCode === 401) {
        var redirectPath = ((_a = error.response.headers) === null || _a === void 0 ? void 0 : _a.get) &&
            typeof error.response.headers.get === 'function' &&
            error.response.headers.get('location') !== null
            ? error.response.headers.get('location')
            : null;
        return redirectPath !== null
            ? {
                shouldRedirect: true,
                redirectPath: redirectPath,
            }
            : noRedirectValue;
    }
    return noRedirectValue;
};
var errorLink = onError(function (_a) {
    var networkError = _a.networkError;
    if (networkError) {
        console.log("[Network error]: " + networkError);
        var _b = shouldRedirectOnNetworkError(networkError), shouldRedirect = _b.shouldRedirect, redirectPath = _b.redirectPath;
        if (shouldRedirect && redirectPath !== null && Boolean(redirectPath)) {
            var currentPath = LocationPathHelper.getPathName() || HOME_PAGE_PATH;
            window.location.href = getIdentityUrl({ nextPath: currentPath });
        }
    }
});
var configureApollo = function (graphqlUrl, experience, bootstrapConfig, options) {
    var appInfo = {
        appName: process.env.APP_NAME,
        appVersion: getReleaseVersion(bootstrapConfig.env),
        appEnv: bootstrapConfig.env || 'local',
        appWebSha: process.env.WEB_SHA,
    };
    var client = configureApolloUtil(__assign({ language: Locale.EN_US, middlewares: [errorLink], appInfo: appInfo,
        graphqlUrl: graphqlUrl,
        experience: experience }, options));
    return client;
};
export default configureApollo;
